import type { DateRange, FuelCardVehicle } from '@cobliteam/common-types';
import type * as Actions from './actions';
import { FuelCardActionTypes as Types } from './fuelCardActionTypes';

export const downloadTransactionsReportRequest = (period: DateRange, vehicleGroupPaths: string[]): Actions.DownloadTransactionsReportRequest => ({
  type: Types.DOWNLOAD_TRANSACTIONS_REPORT_REQUEST,
  payload: {
    period,
    vehicleGroupPaths,
  },
});

export const downloadTransactionsReportEnd = (): Actions.DownloadTransactionsReportEnd => ({
  type: Types.DOWNLOAD_TRANSACTIONS_REPORT_END,
});

export const loadFuelVehiclesRequest = (): Actions.LoadFuelVehiclesRequest => ({
  type: Types.LOAD_FUEL_VEHICLES_REQUEST,
});

export const loadFuelVehiclesSucceeded = (vehicles: FuelCardVehicle[]): Actions.LoadFuelVehiclesSucceeded => ({
  type: Types.LOAD_FUEL_VEHICLES_SUCCEEDED,
  payload: vehicles,
});

export const loadFuelVehiclesFailed = (): Actions.LoadFuelVehiclesFailed => ({
  type: Types.LOAD_FUEL_VEHICLES_FAILED,
});

export const updateFuelVehiclesRequest = (vehicles: FuelCardVehicle[]): Actions.UpdateFuelVehiclesRequest => ({
  type: Types.UPDATE_FUEL_VEHICLES_REQUEST,
  payload: vehicles,
});

export const updateFuelVehiclesEnd = (): Actions.UpdateFuelVehiclesEnd => ({
  type: Types.UPDATE_FUEL_VEHICLES_END,
});
